var _mask, _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _mask2, _path5, _path6, _rect4, _path7, _rect5, _rect6, _mask3, _path8, _path9, _rect7, _path0, _path1, _path10, _path11, _path12, _rect8, _rect9, _path13, _rect0, _path14, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockedStatisticSection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1288,
    height: 112,
    viewBox: "0 0 1288 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_23251_19559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H322V112H12C5.37259 112 0 106.627 0 100V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H322V112H12C5.37259 112 0 106.627 0 100V12Z",
    fill: "#EFEFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H322H0ZM322 112H0H322ZM0 112V0V112ZM324 0V112H320V0H324Z",
    fill: "#E4E4E4",
    mask: "url(#path-1-inside-1_23251_19559)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 48,
    height: 48,
    rx: 6,
    fill: "#6B7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3027 55.7891L53.5027 57.4391C54.5694 58.2391 56.0361 58.2391 57.1027 57.4391L59.3027 55.7891M56.9876 50.7891H50.3027C48.6459 50.7891 47.3027 52.1322 47.3027 53.7891V61.7891C47.3027 63.4459 48.6459 64.7891 50.3027 64.7891H60.3027C61.9596 64.7891 63.3027 63.4459 63.3027 61.7891V53.7891C63.3027 53.5492 63.3027 53.3549 63.3027 53.3549",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.709 48.5078C61.709 48.0936 61.3732 47.7578 60.959 47.7578C60.5448 47.7578 60.209 48.0936 60.209 48.5078H60.959H61.709ZM60.959 50.0078H60.209C60.209 50.422 60.5448 50.7578 60.959 50.7578V50.0078ZM62.459 50.7578C62.8732 50.7578 63.209 50.422 63.209 50.0078C63.209 49.5936 62.8732 49.2578 62.459 49.2578V50.0078V50.7578ZM64.959 50.0078H64.209C64.209 51.8027 62.7539 53.2578 60.959 53.2578V54.0078V54.7578C63.5823 54.7578 65.709 52.6312 65.709 50.0078H64.959ZM60.959 54.0078V53.2578C59.1641 53.2578 57.709 51.8027 57.709 50.0078H56.959H56.209C56.209 52.6312 58.3356 54.7578 60.959 54.7578V54.0078ZM56.959 50.0078H57.709C57.709 48.2129 59.1641 46.7578 60.959 46.7578V46.0078V45.2578C58.3356 45.2578 56.209 47.3845 56.209 50.0078H56.959ZM60.959 46.0078V46.7578C62.7539 46.7578 64.209 48.2129 64.209 50.0078H64.959H65.709C65.709 47.3845 63.5823 45.2578 60.959 45.2578V46.0078ZM60.959 48.5078H60.209V50.0078H60.959H61.709V48.5078H60.959ZM60.959 50.0078V50.7578H62.459V50.0078V49.2578H60.959V50.0078Z",
    fill: "#E4E4E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 34.1992,
    width: 127,
    height: 17.6,
    rx: 4,
    fill: "#C8C7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 64.1133,
    width: 43,
    height: 11.2,
    rx: 4,
    fill: "#C8C7FF"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_23251_19559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322 0H644V112H322V0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322 0H644V112H322V0Z",
    fill: "#EFEFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M644 0H642V112H644H646V0H644Z",
    fill: "#E4E4E4",
    mask: "url(#path-8-inside-2_23251_19559)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 32,
    width: 48,
    height: 48,
    rx: 6,
    fill: "#6B7DE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.5 56.5L374.7 58.15C375.767 58.95 377.233 58.95 378.3 58.15L380.5 56.5M384.719 50.5239L382.865 48.2063C382.629 47.9109 382.5 47.5439 382.5 47.1657V47.091C382.5 46.2123 383.212 45.5 384.091 45.5C384.513 45.5 384.918 45.6676 385.216 45.966L385.5 46.25L385.784 45.966C386.082 45.6676 386.487 45.5 386.909 45.5C387.788 45.5 388.5 46.2123 388.5 47.091V47.1657C388.5 47.5439 388.371 47.9109 388.135 48.2063L386.281 50.5239C385.881 51.0243 385.119 51.0243 384.719 50.5239ZM371.5 65.5H381.5C383.157 65.5 384.5 64.1569 384.5 62.5V54.5C384.5 52.8431 383.157 51.5 381.5 51.5H371.5C369.843 51.5 368.5 52.8431 368.5 54.5V62.5C368.5 64.1569 369.843 65.5 371.5 65.5Z",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 35.1992,
    width: 105,
    height: 17.6,
    rx: 4,
    fill: "#C8C7FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 65.1602,
    width: 157,
    height: 11.2,
    rx: 4,
    fill: "#C8C7FF"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-3_23251_19559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644 0H966V112H644V0Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M644 0H966V112H644V0Z",
    fill: "#EFEFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M966 0H964V112H966H968V0H966Z",
    fill: "#E4E4E4",
    mask: "url(#path-14-inside-3_23251_19559)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 32,
    width: 48,
    height: 48,
    rx: 6,
    fill: "#6B7DE5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M700 66C705.523 66 710 61.5228 710 56C710 50.4772 705.523 46 700 46",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M700 66C694.477 66 690 61.5228 690 56C690 50.4772 694.477 46 700 46",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M701.5 56C701.5 56.8284 700.828 57.5 700 57.5C699.172 57.5 698.5 56.8284 698.5 56C698.5 55.1716 699.172 54.5 700 54.5C700.828 54.5 701.5 55.1716 701.5 56Z",
    stroke: "#E4E4E4",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M700 57.5L700 59.25V60",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M700 50V52.5L700 54.5",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 35.1992,
    width: 130,
    height: 17.6,
    rx: 4,
    fill: "#C8C7FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 66.2539,
    width: 155,
    height: 11.2,
    rx: 4,
    fill: "#C8C7FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M966 0H1276C1282.63 0 1288 5.37258 1288 12V100C1288 106.627 1282.63 112 1276 112H966V0Z",
    fill: "#EFEFFF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 32,
    width: 48,
    height: 48,
    rx: 6,
    fill: "#6B7DE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.5 45.5L1031.79 46.7929C1032.18 47.1834 1032.18 47.8166 1031.79 48.2071L1030.5 49.5M1026.5 47.5H1031.5M1016.5 56.5L1018.7 58.15C1019.77 58.95 1021.23 58.95 1022.3 58.15L1024.5 56.5M1015.5 65.5H1025.5C1027.16 65.5 1028.5 64.1569 1028.5 62.5V54.5C1028.5 52.8431 1027.16 51.5 1025.5 51.5H1015.5C1013.84 51.5 1012.5 52.8431 1012.5 54.5V62.5C1012.5 64.1569 1013.84 65.5 1015.5 65.5Z",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 35.1992,
    width: 121,
    height: 17.6,
    rx: 4,
    fill: "#C8C7FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 64.2539,
    width: 131,
    height: 11.2,
    rx: 4,
    fill: "#C8C7FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockedStatisticSection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locked_statistic_section.4b496718f8f84a5ccc7552676d9d82a3.svg";